import React, { useContext, useEffect, useState } from "react";
import AppLayout, {
  AppLayoutProps,
} from "@amzn/awsui-components-console/app-layout";
import { NonCancelableCustomEvent } from "@amzn/awsui-components-console";
import { Navigation } from "src/pages/commons";
import { URLS } from "src/components/constants/appConstants";
import "../commons/common.styles.scss";
import { appLayoutAriaLabels } from "src/i18n-strings/app-layout";
import { AppUnbilledArAging } from "src/components/unbilledArAgingPage/unbilled-ar-aging-page";
import { InitDomain } from "src/context/domain/domainContext";
import { configureDomain } from "src/auth/config";
import { useSettingsStore } from "src/stores/useSettingsStore";
import { resolveInitialPanelState } from "src/hooks/useInitialPanelState";

export function UnbilledArAging() {
  const { navPanelBehavior, toolsPanelBehavior } = useSettingsStore();
  const [navigationOpen, setNavigationOpen] = React.useState(
    resolveInitialPanelState(false, navPanelBehavior),
  );
  const [toolsOpen, setToolsOpen] = useState(
    resolveInitialPanelState(false, toolsPanelBehavior),
  );
  const { setDomain } = useContext(InitDomain);

  useEffect(() => {
    setDomain("Global");
    return () => {
      setDomain(configureDomain);
    };
  }, []);

  return (
    <AppLayout
      disableContentPaddings
      content={<AppUnbilledArAging />}
      navigation={<Navigation activeHref={URLS.UNBILLED_AR_AGING} />}
      navigationOpen={navigationOpen}
      onNavigationChange={({ detail }) => setNavigationOpen(detail.open)}
      toolsOpen={toolsOpen}
      onToolsChange={({ detail }) => setToolsOpen(detail.open)}
      ariaLabels={appLayoutAriaLabels}
    />
  );
}
